// myProductUtil.js

// 定义一个Map来存储所有的翻译数据
const translations = new Map([
    ["en", {
        "afghanistan": "Afghanistan",
        "albania": "Albania",
        "algeria": "Algeria",
        "american samoa": "American Samoa",
        "andorra": "Andorra",
        "angola": "Angola",
        "anguilla": "Anguilla",
        "antigua and barbuda": "Antigua and Barbuda",
        "argentina": "Argentina",
        "armenia": "Armenia",
        "aruba": "Aruba",
        "australia": "Australia",
        "austria": "Austria",
        "azerbaijan": "Azerbaijan",
        "bahamas": "Bahamas",
        "bahrain": "Bahrain",
        "bangladesh": "Bangladesh",
        "barbados": "Barbados",
        "belarus": "Belarus",
        "belgium": "Belgium",
        "belize": "Belize",
        "benin": "Benin",
        "bermuda": "Bermuda",
        "bhutan": "Bhutan",
        "bolivia": "Bolivia",
        "botswana": "Botswana",
        "brazil": "Brazil",
        "bulgaria": "Bulgaria",
        "burkina faso": "Burkina Faso",
        "burundi": "Burundi",
        "cambodia": "Cambodia",
        "cameroon": "Cameroon",
        "canada": "Canada",
        "cape verde": "Cape Verde",
        "cayman islands": "Cayman Islands",
        "central african republic": "Central African Republic",
        "chad": "Chad",
        "chile": "Chile",
        "christmas island": "Christmas Island",
        "cocos (keeling) islands": "Cocos (Keeling) Islands",
        "colombia": "Colombia",
        "comoros": "Comoros",
        "cook islands": "Cook Islands",
        "costa rica": "Costa Rica",
        "cote d'ivoire": "Cote D'Ivoire",
        "croatia": "Croatia",
        "cyprus": "Cyprus",
        "czech republic": "Czech Republic",
        "denmark": "Denmark",
        "djibouti": "Djibouti",
        "dominica": "Dominica",
        "dominican republic": "Dominican Republic",
        "ecuador": "Ecuador",
        "egypt": "Egypt",
        "el salvador": "El Salvador",
        "equatorial guinea": "Equatorial Guinea",
        "eritrea": "Eritrea",
        "estonia": "Estonia",
        "ethiopia": "Ethiopia",
        "falkland islands (malvinas)": "Falkland Islands (Malvinas)",
        "faroe islands": "Faroe Islands",
        "fiji": "Fiji",
        "finland": "Finland",
        "france": "France",
        "french guiana": "French Guiana",
        "french polynesia": "French Polynesia",
        "gabon": "Gabon",
        "gambia": "Gambia",
        "georgia": "Georgia",
        "germany": "Germany",
        "ghana": "Ghana",
        "gibraltar": "Gibraltar",
        "greece": "Greece",
        "greenland": "Greenland",
        "grenada": "Grenada",
        "guadeloupe": "Guadeloupe",
        "guam": "Guam",
        "guatemala": "Guatemala",
        "guinea": "Guinea",
        "guinea-bissau": "Guinea-Bissau",
        "guyana": "Guyana",
        "haiti": "Haiti",
        "honduras": "Honduras",
        "hungary": "Hungary",
        "iceland": "Iceland",
        "india": "India",
        "iraq": "Iraq",
        "ireland": "Ireland",
        "israel": "Israel",
        "italy": "Italy",
        "jamaica": "Jamaica",
        "japan": "Japan",
        "jordan": "Jordan",
        "kazakhstan": "Kazakhstan",
        "kenya": "Kenya",
        "kiribati": "Kiribati",
        "kuwait": "Kuwait",
        "kyrgyzstan": "Kyrgyzstan",
        "lao people's democratic republic": "Lao People's Democratic Republic",
        "latvia": "Latvia",
        "lebanon": "Lebanon",
        "lesotho": "Lesotho",
        "liberia": "Liberia",
        "liechtenstein": "Liechtenstein",
        "lithuania": "Lithuania",
        "luxembourg": "Luxembourg",
        "madagascar": "Madagascar",
        "malawi": "Malawi",
        "malaysia": "Malaysia",
        "maldives": "Maldives",
        "mali": "Mali",
        "malta": "Malta",
        "marshall islands": "Marshall Islands",
        "martinique": "Martinique",
        "mauritania": "Mauritania",
        "mauritius": "Mauritius",
        "mayotte": "Mayotte",
        "mexico": "Mexico",
        "monaco": "Monaco",
        "mongolia": "Mongolia",
        "montserrat": "Montserrat",
        "morocco": "Morocco",
        "mozambique": "Mozambique",
        "myanmar": "Myanmar",
        "namibia": "Namibia",
        "nauru": "Nauru",
        "nepal": "Nepal",
        "netherlands": "Netherlands",
        "netherlands antilles": "Netherlands Antilles",
        "new caledonia": "New Caledonia",
        "new zealand": "New Zealand",
        "nicaragua": "Nicaragua",
        "niger": "Niger",
        "nigeria": "Nigeria",
        "niue": "Niue",
        "norfolk island": "Norfolk Island",
        "northern mariana islands": "Northern Mariana Islands",
        "norway": "Norway",
        "oman": "Oman",
        "pakistan": "Pakistan",
        "palau": "Palau",
        "panama": "Panama",
        "papua new guinea": "Papua New Guinea",
        "paraguay": "Paraguay",
        "peru": "Peru",
        "philippines": "Philippines",
        "poland": "Poland",
        "portugal": "Portugal",
        "puerto rico": "Puerto Rico",
        "qatar": "Qatar",
        "reunion": "Reunion",
        "romania": "Romania",
        "russian federation": "Russian Federation",
        "rwanda": "Rwanda",
        "saint kitts and nevis": "Saint Kitts and Nevis",
        "saint lucia": "Saint Lucia",
        "saint vincent and the grenadines": "Saint Vincent and the Grenadines",
        "samoa": "Samoa",
        "san marino": "San Marino",
        "sao tome and principe": "Sao Tome and Principe",
        "saudi arabia": "Saudi Arabia",
        "senegal": "Senegal",
        "seychelles": "Seychelles",
        "sierra leone": "Sierra Leone",
        "singapore": "Singapore",
        "slovakia": "Slovakia",
        "slovenia": "Slovenia",
        "solomon islands": "Solomon Islands",
        "somalia": "Somalia",
        "south africa": "South Africa",
        "south georgia and the south sandwich islands": "South Georgia and the South Sandwich Islands",
        "south korea": "South Korea",
        "spain": "Spain",
        "sri lanka": "Sri Lanka",
        "suriname": "Suriname",
        "swaziland": "Swaziland",
        "sweden": "Sweden",
        "switzerland": "Switzerland",
        "tajikistan": "Tajikistan",
        "thailand": "Thailand",
        "timor-leste": "Timor-Leste",
        "togo": "Togo",
        "tonga": "Tonga",
        "trinidad and tobago": "Trinidad and Tobago",
        "tunisia": "Tunisia",
        "turkey": "Turkey",
        "turkmenistan": "Turkmenistan",
        "tuvalu": "Tuvalu",
        "uganda": "Uganda",
        "ukraine": "Ukraine",
        "united arab emirates": "United Arab Emirates",
        "united kingdom": "United Kingdom",
        "united states": "United States",
        "uruguay": "Uruguay",
        "uzbekistan": "Uzbekistan",
        "vanuatu": "Vanuatu",
        "vatican city state (holy see)": "Vatican City State (Holy See)",
        "venezuela": "Venezuela",
        "virgin islands (british)": "Virgin Islands (British)",
        "virgin islands (u.s.)": "Virgin Islands (U.S.)",
        "wallis and futuna islands": "Wallis And Futuna Islands",
        "yemen": "Yemen",
        "zambia": "Zambia",
        "zimbabwe": "Zimbabwe",
        // 英语
    }],
    ["zh", {
        "afghanistan": "阿富汗",
        "albania": "阿尔巴尼亚",
        "algeria": "阿尔及利亚",
        "american samoa": "美属萨摩亚",
        "andorra": "安道尔",
        "angola": "安哥拉",
        "anguilla": "安圭拉",
        "antigua and barbuda": "安提瓜和巴布达",
        "argentina": "阿根廷",
        "armenia": "亚美尼亚",
        "aruba": "阿鲁巴",
        "australia": "澳大利亚",
        "austria": "奥地利",
        "azerbaijan": "阿塞拜疆",
        "bahamas": "巴哈马",
        "bahrain": "巴林",
        "bangladesh": "孟加拉国",
        "barbados": "巴巴多斯",
        "belarus": "白俄罗斯",
        "belgium": "比利时",
        "belize": "伯利兹",
        "benin": "贝宁",
        "bermuda": "百慕大",
        "bhutan": "不丹",
        "bolivia": "玻利维亚",
        "botswana": "博茨瓦纳",
        "brazil": "巴西",
        "bulgaria": "保加利亚",
        "burkina faso": "布基纳法索",
        "burundi": "布隆迪",
        "cambodia": "柬埔寨",
        "cameroon": "喀麦隆",
        "canada": "加拿大",
        "cape verde": "佛得角",
        "cayman islands": "开曼群岛",
        "central african republic": "中非共和国",
        "chad": "乍得",
        "chile": "智利",
        "christmas island": "圣诞岛",
        "cocos (keeling) islands": "科科斯（基林）群岛",
        "colombia": "哥伦比亚",
        "comoros": "科摩罗",
        "cook islands": "库克群岛",
        "costa rica": "哥斯达黎加",
        "cote d'ivoire": "科特迪瓦",
        "croatia": "克罗地亚",
        "cyprus": "塞浦路斯",
        "czech republic": "捷克共和国",
        "denmark": "丹麦",
        "djibouti": "吉布提",
        "dominica": "多米尼加",
        "dominican republic": "多米尼加共和国",
        "ecuador": "厄瓜多尔",
        "egypt": "埃及",
        "el salvador": "萨尔瓦多",
        "equatorial guinea": "赤道几内亚",
        "eritrea": "厄立特里亚",
        "estonia": "爱沙尼亚",
        "ethiopia": "埃塞俄比亚",
        "falkland islands (malvinas)": "福克兰群岛（马尔维纳斯群岛）",
        "faroe islands": "法罗群岛",
        "fiji": "斐济",
        "finland": "芬兰",
        "france": "法国",
        "french guiana": "法属圭亚那",
        "french polynesia": "法属波利尼西亚",
        "gabon": "加蓬",
        "gambia": "冈比亚",
        "georgia": "格鲁吉亚",
        "germany": "德国",
        "ghana": "加纳",
        "gibraltar": "直布罗陀",
        "greece": "希腊",
        "greenland": "格陵兰",
        "grenada": "格林纳达",
        "guadeloupe": "瓜德罗普岛",
        "guam": "关岛",
        "guatemala": "危地马拉",
        "guinea": "几内亚",
        "guinea-bissau": "几内亚比绍",
        "guyana": "圭亚那",
        "haiti": "海地",
        "honduras": "洪都拉斯",
        "hungary": "匈牙利",
        "iceland": "冰岛",
        "india": "印度",
        "iraq": "伊拉克",
        "ireland": "爱尔兰",
        "israel": "以色列",
        "italy": "意大利",
        "jamaica": "牙买加",
        "japan": "日本",
        "jordan": "约旦",
        "kazakhstan": "哈萨克斯坦",
        "kenya": "肯尼亚",
        "kiribati": "基里巴斯",
        "kuwait": "科威特",
        "kyrgyzstan": "吉尔吉斯斯坦",
        "lao people's democratic republic": "老挝人民民主共和国",
        "latvia": "拉脱维亚",
        "lebanon": "黎巴嫩",
        "lesotho": "莱索托",
        "liberia": "利比里亚",
        "liechtenstein": "列支敦士登",
        "lithuania": "立陶宛",
        "luxembourg": "卢森堡",
        "madagascar": "马达加斯加",
        "malawi": "马拉维",
        "malaysia": "马来西亚",
        "maldives": "马尔代夫",
        "mali": "马里",
        "malta": "马耳他",
        "marshall islands": "马绍尔群岛",
        "martinique": "马提尼克",
        "mauritania": "毛里塔尼亚",
        "mauritius": "毛里求斯",
        "mayotte": "马约特",
        "mexico": "墨西哥",
        "monaco": "摩纳哥",
        "mongolia": "蒙古",
        "montserrat": "蒙特塞拉特",
        "morocco": "摩洛哥",
        "mozambique": "莫桑比克",
        "myanmar": "缅甸",
        "namibia": "纳米比亚",
        "nauru": "瑙鲁",
        "nepal": "尼泊尔",
        "netherlands": "荷兰",
        "netherlands antilles": "荷属安的列斯",
        "new caledonia": "新喀里多尼亚",
        "new zealand": "新西兰",
        "nicaragua": "尼加拉瓜",
        "niger": "尼日尔",
        "nigeria": "尼日利亚",
        "niue": "纽埃",
        "norfolk island": "诺福克岛",
        "northern mariana islands": "北马里亚纳群岛",
        "norway": "挪威",
        "oman": "阿曼",
        "pakistan": "巴基斯坦",
        "palau": "帕劳",
        "panama": "巴拿马",
        "papua new guinea": "巴布亚新几内亚",
        "paraguay": "巴拉圭",
        "peru": "秘鲁",
        "philippines": "菲律宾",
        "poland": "波兰",
        "portugal": "葡萄牙",
        "puerto rico": "波多黎各",
        "qatar": "卡塔尔",
        "reunion": "留尼汪",
        "romania": "罗马尼亚",
        "russian federation": "俄罗斯联邦",
        "rwanda": "卢旺达",
        "saint kitts and nevis": "圣基茨和尼维斯",
        "saint lucia": "圣卢西亚",
        "saint vincent and the grenadines": "圣文森特和格林纳丁斯",
        "samoa": "萨摩亚",
        "san marino": "圣马力诺",
        "sao tome and principe": "圣多美和普林西比",
        "saudi arabia": "沙特阿拉伯",
        "senegal": "塞内加尔",
        "seychelles": "塞舌尔",
        "sierra leone": "塞拉利昂",
        "singapore": "新加坡",
        "slovakia": "斯洛伐克",
        "slovenia": "斯洛文尼亚",
        "solomon islands": "所罗门群岛",
        "somalia": "索马里",
        "south africa": "南非",
        "south georgia and the south sandwich islands": "南乔治亚岛和南桑威奇群岛",
        "south korea": "韩国",
        "spain": "西班牙",
        "sri lanka": "斯里兰卡",
        "suriname": "苏里南",
        "swaziland": "斯威士兰",
        "sweden": "瑞典",
        "switzerland": "瑞士",
        "tajikistan": "塔吉克斯坦",
        "thailand": "泰国",
        "timor-leste": "东帝汶",
        "togo": "多哥",
        "tonga": "汤加",
        "trinidad and tobago": "特立尼达和多巴哥",
        "tunisia": "突尼斯",
        "turkey": "土耳其",
        "turkmenistan": "土库曼斯坦",
        "tuvalu": "图瓦卢",
        "uganda": "乌干达",
        "ukraine": "乌克兰",
        "united arab emirates": "阿联酋",
        "united kingdom": "英国",
        "united states": "美国",
        "uruguay": "乌拉圭",
        "uzbekistan": "乌兹别克斯坦",
        "vanuatu": "瓦努阿图",
        "vatican city state (holy see)": "梵蒂冈城国（圣座）",
        "venezuela": "委内瑞拉",
        "virgin islands (british)": "英属维尔京群岛",
        "virgin islands (u.s.)": "美属维尔京群岛",
        "wallis and futuna islands": "瓦利斯和富图纳群岛",
        "yemen": "也门",
        "zambia": "赞比亚",
        "zimbabwe": "津巴布韦"
    }],
    ["ar", {
        "afghanistan": "أفغانستان",
        "albania": "ألبانيا",
        "algeria": "الجزائر",
        "american samoa": "ساموا الأمريكية",
        "andorra": "أندورا",
        "angola": "أنغولا",
        "anguilla": "أنغيلا",
        "antigua and barbuda": "أنتيغوا وباربودا",
        "argentina": "الأرجنتين",
        "armenia": "أرمينيا",
        "aruba": "أروبا",
        "australia": "أستراليا",
        "austria": "النمسا",
        "azerbaijan": "أذربيجان",
        "bahamas": "الباهاماس",
        "bahrain": "البحرين",
        "bangladesh": "بنغلاديش",
        "barbados": "بربادوس",
        "belarus": "بيلاروسيا",
        "belgium": "بلجيكا",
        "belize": "بليز",
        "benin": "بنين",
        "bermuda": "برمودا",
        "bhutan": "بوتان",
        "bolivia": "بوليفيا",
        "botswana": "بوتسوانا",
        "brazil": "البرازيل",
        "bulgaria": "بلغاريا",
        "burkina faso": "بوركينا فاسو",
        "burundi": "بوروندي",
        "cambodia": "كمبوديا",
        "cameroon": "الكاميرون",
        "canada": "كندا",
        "cape verde": "الرأس الأخضر",
        "cayman islands": "جزر كايمان",
        "central african republic": "جمهورية أفريقيا الوسطى",
        "chad": "تشاد",
        "chile": "تشيلي",
        "christmas island": "جزيرة الكريسماس",
        "cocos (keeling) islands": "جزر كوكوس (كيلينغ)",
        "colombia": "كولومبيا",
        "comoros": "جزر القمر",
        "cook islands": "جزر كوك",
        "costa rica": "كوستاريكا",
        "cote d'ivoire": "ساحل العاج",
        "croatia": "كرواتيا",
        "cyprus": "قبرص",
        "czech republic": "جمهورية التشيك",
        "denmark": "الدنمارك",
        "djibouti": "جيبوتي",
        "dominica": "دومينيكا",
        "dominican republic": "جمهورية الدومينيكان",
        "ecuador": "الإكوادور",
        "egypt": "مصر",
        "el salvador": "السلفادور",
        "equatorial guinea": "غينيا الاستوائية",
        "eritrea": "إريتريا",
        "estonia": "إستونيا",
        "ethiopia": "إثيوبيا",
        "falkland islands (malvinas)": "جزر فوكلاند (مالفيناس)",
        "faroe islands": "جزر فارو",
        "fiji": "فيجي",
        "finland": "فنلندا",
        "france": "فرنسا",
        "french guiana": "غويانا الفرنسية",
        "french polynesia": "بولينيزيا الفرنسية",
        "gabon": "الغابون",
        "gambia": "غامبيا",
        "georgia": "جورجيا",
        "germany": "ألمانيا",
        "ghana": "غانا",
        "gibraltar": "جبل طارق",
        "greece": "اليونان",
        "greenland": "غرينلاند",
        "grenada": "غرينادا",
        "guadeloupe": "غوادلوب",
        "guam": "غوام",
        "guatemala": "غواتيمالا",
        "guinea": "غينيا",
        "guinea-bissau": "غينيا بيساو",
        "guyana": "غويانا",
        "haiti": "هايتي",
        "honduras": "هندوراس",
        "hungary": "هنغاريا",
        "iceland": "آيسلندا",
        "india": "الهند",
        "iraq": "العراق",
        "ireland": "أيرلندا",
        "israel": "إسرائيل",
        "italy": "إيطاليا",
        "jamaica": "جامايكا",
        "japan": "اليابان",
        "jordan": "الأردن",
        "kazakhstan": "كازاخستان",
        "kenya": "كينيا",
        "kiribati": "كيريباتي",
        "kuwait": "الكويت",
        "kyrgyzstan": "قيرغيزستان",
        "lao people's democratic republic": "جمهورية لاو الشعبية الديمقراطية",
        "latvia": "لاتفيا",
        "lebanon": "لبنان",
        "lesotho": "ليسوتو",
        "liberia": "ليبيريا",
        "liechtenstein": "ليختنشتاين",
        "lithuania": "ليتوانيا",
        "luxembourg": "لوكسمبورغ",
        "madagascar": "مدغشقر",
        "malawi": "مالاوي",
        "malaysia": "ماليزيا",
        "maldives": "المالديف",
        "mali": "مالي",
        "malta": "مالطا",
        "marshall islands": "جزر مارشال",
        "martinique": "مارتينيك",
        "mauritania": "موريتانيا",
        "mauritius": "موريشيوس",
        "mayotte": "مايوت",
        "mexico": "المكسيك",
        "monaco": "موناكو",
        "mongolia": "منغوليا",
        "montserrat": "مونتسيرات",
        "morocco": "المغرب",
        "mozambique": "موزمبيق",
        "myanmar": "ميانمار",
        "namibia": "ناميبيا",
        "nauru": "ناورو",
        "nepal": "نيبال",
        "netherlands": "هولندا",
        "netherlands antilles": "جزر الهند الغربية الهولندية",
        "new caledonia": "كاليدونيا الجديدة",
        "new zealand": "نيوزيلندا",
        "nicaragua": "نيكاراغوا",
        "niger": "النيجر",
        "nigeria": "نيجيريا",
        "niue": "نيوي",
        "norfolk island": "جزيرة نورفولك",
        "northern mariana islands": "جزر ماريانا الشمالية",
        "norway": "النرويج",
        "oman": "عمان",
        "pakistan": "باكستان",
        "palau": "بالاو",
        "panama": "بنما",
        "papua new guinea": "بابوا غينيا الجديدة",
        "paraguay": "باراغواي",
        "peru": "بيرو",
        "philippines": "الفلبين",
        "poland": "بولندا",
        "portugal": "البرتغال",
        "puerto rico": "بورتو ريكو",
        "qatar": "قطر",
        "reunion": "لا ريونيون",
        "romania": "رومانيا",
        "russian federation": "الاتحاد الروسي",
        "rwanda": "رواندا",
        "saint kitts and nevis": "سانت كيتس ونيفيس",
        "saint lucia": "سانت لوسيا",
        "saint vincent and the grenadines": "سانت فينسنت وجزر غرينادين",
        "samoa": "ساموا",
        "san marino": "سان مارينو",
        "sao tome and principe": "ساو تومي وبرينسيبي",
        "saudi arabia": "المملكة العربية السعودية",
        "senegal": "السنغال",
        "seychelles": "سيشيل",
        "sierra leone": "سيرا ليون",
        "singapore": "سنغافورة",
        "slovakia": "سلوفاكيا",
        "slovenia": "سلوفينيا",
        "solomon islands": "جزر سليمان",
        "somalia": "الصومال",
        "south africa": "جنوب أفريقيا",
        "south georgia and the south sandwich islands": "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
        "south korea": "كوريا الجنوبية",
        "spain": "إسبانيا",
        "sri lanka": "سريلانكا",
        "suriname": "سورينام",
        "swaziland": "سوازيلاند",
        "sweden": "السويد",
        "switzerland": "سويسرا",
        "tajikistan": "طاجيكستان",
        "thailand": "تايلاند",
        "timor-leste": "تيمور الشرقية",
        "togo": "توجو",
        "tonga": "تونغا",
        "trinidad and tobago": "ترينيداد وتوباغو",
        "tunisia": "تونس",
        "turkey": "تركيا",
        "turkmenistan": "تركمانستان",
        "tuvalu": "توفالو",
        "uganda": "أوغندا",
        "ukraine": "أوكرانيا",
        "united arab emirates": "الإمارات العربية المتحدة",
        "united kingdom": "المملكة المتحدة",
        "united states": "الولايات المتحدة",
        "uruguay": "أوروغواي",
        "uzbekistan": "أوزبكستان",
        "vanuatu": "فانواتو",
        "vatican city state (holy see)": "دولة الفاتيكان (الكرسي الرسولي)",
        "venezuela": "فنزويلا",
        "virgin islands (british)": "جزر فيرجن البريطانية",
        "virgin islands (u.s.)": "جزر فيرجن الأمريكية",
        "wallis and futuna islands": "جزر واليس وفوتونا",
        "yemen": "اليمن",
        "zambia": "زامبيا",
        "zimbabwe": "زيمبابوي",
        // 阿拉伯语
    }],
    ["es", {
        "afghanistan": "Afganistán",
        "albania": "Albania",
        "algeria": "Argelia",
        "american samoa": "Samoa Americana",
        "andorra": "Andorra",
        "angola": "Angola",
        "anguilla": "Anguila",
        "antigua and barbuda": "Antigua y Barbuda",
        "argentina": "Argentina",
        "armenia": "Armenia",
        "aruba": "Aruba",
        "australia": "Australia",
        "austria": "Austria",
        "azerbaijan": "Azerbaiyán",
        "bahamas": "Bahamas",
        "bahrain": "Baréin",
        "bangladesh": "Bangladés",
        "barbados": "Barbados",
        "belarus": "Bielorrusia",
        "belgium": "Bélgica",
        "belize": "Belice",
        "benin": "Benín",
        "bermuda": "Bermudas",
        "bhutan": "Bután",
        "bolivia": "Bolivia",
        "botswana": "Botsuana",
        "brazil": "Brasil",
        "bulgaria": "Bulgaria",
        "burkina faso": "Burkina Faso",
        "burundi": "Burundi",
        "cambodia": "Camboya",
        "cameroon": "Camerún",
        "canada": "Canadá",
        "cape verde": "Cabo Verde",
        "cayman islands": "Islas Caimán",
        "central african republic": "República Centroafricana",
        "chad": "Chad",
        "chile": "Chile",
        "christmas island": "Isla de Navidad",
        "cocos (keeling) islands": "Islas Cocos (Keeling)",
        "colombia": "Colombia",
        "comoros": "Comoras",
        "cook islands": "Islas Cook",
        "costa rica": "Costa Rica",
        "cote d'ivoire": "Costa de Marfil",
        "croatia": "Croacia",
        "cyprus": "Chipre",
        "czech republic": "República Checa",
        "denmark": "Dinamarca",
        "djibouti": "Yibuti",
        "dominica": "Dominica",
        "dominican republic": "República Dominicana",
        "ecuador": "Ecuador",
        "egypt": "Egipto",
        "el salvador": "El Salvador",
        "equatorial guinea": "Guinea Ecuatorial",
        "eritrea": "Eritrea",
        "estonia": "Estonia",
        "ethiopia": "Etiopía",
        "falkland islands (malvinas)": "Islas Malvinas (Falkland)",
        "faroe islands": "Islas Feroe",
        "fiji": "Fiyi",
        "finland": "Finlandia",
        "france": "Francia",
        "french guiana": "Guayana Francesa",
        "french polynesia": "Polinesia Francesa",
        "gabon": "Gabón",
        "gambia": "Gambia",
        "georgia": "Georgia",
        "germany": "Alemania",
        "ghana": "Ghana",
        "gibraltar": "Gibraltar",
        "greece": "Grecia",
        "greenland": "Groenlandia",
        "grenada": "Granada",
        "guadeloupe": "Guadalupe",
        "guam": "Guam",
        "guatemala": "Guatemala",
        "guinea": "Guinea",
        "guinea-bissau": "Guinea-Bisáu",
        "guyana": "Guyana",
        "haiti": "Haití",
        "honduras": "Honduras",
        "hungary": "Hungría",
        "iceland": "Islandia",
        "india": "India",
        "iraq": "Irak",
        "ireland": "Irlanda",
        "israel": "Israel",
        "italy": "Italia",
        "jamaica": "Jamaica",
        "japan": "Japón",
        "jordan": "Jordania",
        "kazakhstan": "Kazajistán",
        "kenya": "Kenia",
        "kiribati": "Kiribati",
        "kuwait": "Kuwait",
        "kyrgyzstan": "Kirguistán",
        "lao people's democratic republic": "República Democrática Popular de Laos",
        "latvia": "Letonia",
        "lebanon": "Líbano",
        "lesotho": "Lesoto",
        "liberia": "Liberia",
        "liechtenstein": "Liechtenstein",
        "lithuania": "Lituania",
        "luxembourg": "Luxemburgo",
        "madagascar": "Madagascar",
        "malawi": "Malaui",
        "malaysia": "Malasia",
        "maldives": "Maldivas",
        "mali": "Malí",
        "malta": "Malta",
        "marshall islands": "Islas Marshall",
        "martinique": "Martinica",
        "mauritania": "Mauritania",
        "mauritius": "Mauricio",
        "mayotte": "Mayotte",
        "mexico": "México",
        "monaco": "Mónaco",
        "mongolia": "Mongolia",
        "montserrat": "Montserrat",
        "morocco": "Marruecos",
        "mozambique": "Mozambique",
        "myanmar": "Birmania",
        "namibia": "Namibia",
        "nauru": "Naurú",
        "nepal": "Nepal",
        "netherlands": "Países Bajos",
        "netherlands antilles": "Antillas Neerlandesas",
        "new caledonia": "Nueva Caledonia",
        "new zealand": "Nueva Zelanda",
        "nicaragua": "Nicaragua",
        "niger": "Níger",
        "nigeria": "Nigeria",
        "niue": "Niue",
        "norfolk island": "Isla Norfolk",
        "northern mariana islands": "Islas Marianas del Norte",
        "norway": "Noruega",
        "oman": "Omán",
        "pakistan": "Pakistán",
        "palau": "Palau",
        "panama": "Panamá",
        "papua new guinea": "Papúa Nueva Guinea",
        "paraguay": "Paraguay",
        "peru": "Perú",
        "philippines": "Filipinas",
        "poland": "Polonia",
        "portugal": "Portugal",
        "puerto rico": "Puerto Rico",
        "qatar": "Catar",
        "reunion": "Reunión",
        "romania": "Rumanía",
        "russian federation": "Federación Rusa",
        "rwanda": "Ruanda",
        "saint kitts and nevis": "San Cristóbal y Nieves",
        "saint lucia": "Santa Lucía",
        "saint vincent and the grenadines": "San Vicente y las Granadinas",
        "samoa": "Samoa",
        "san marino": "San Marino",
        "sao tome and principe": "Santo Tomé y Príncipe",
        "saudi arabia": "Arabia Saudita",
        "senegal": "Senegal",
        "seychelles": "Seychelles",
        "sierra leone": "Sierra Leona",
        "singapore": "Singapur",
        "slovakia": "Eslovaquia",
        "slovenia": "Eslovenia",
        "solomon islands": "Islas Salomón",
        "somalia": "Somalia",
        "south africa": "Sudáfrica",
        "south georgia and the south sandwich islands": "Georgia del Sur y las Islas Sandwich del Sur",
        "south korea": "Corea del Sur",
        "spain": "España",
        "sri lanka": "Sri Lanka",
        "suriname": "Surinam",
        "swaziland": "Suazilandia",
        "sweden": "Suecia",
        "switzerland": "Suiza",
        "tajikistan": "Tayikistán",
        "thailand": "Tailandia",
        "timor-leste": "Timor Oriental",
        "togo": "Togo",
        "tonga": "Tonga",
        "trinidad and tobago": "Trinidad y Tobago",
        "tunisia": "Túnez",
        "turkey": "Turquía",
        "turkmenistan": "Turkmenistán",
        "tuvalu": "Tuvalu",
        "uganda": "Uganda",
        "ukraine": "Ucrania",
        "united arab emirates": "Emiratos Árabes Unidos",
        "united kingdom": "Reino Unido",
        "united states": "Estados Unidos",
        "uruguay": "Uruguay",
        "uzbekistan": "Uzbekistán",
        "vanuatu": "Vanuatu",
        "vatican city state (holy see)": "Estado de la Ciudad del Vaticano (Santa Sede)",
        "venezuela": "Venezuela",
        "virgin islands (british)": "Islas Vírgenes Británicas",
        "virgin islands (u.s.)": "Islas Vírgenes de los EE. UU.",
        "wallis and futuna islands": "Islas Wallis y Futuna",
        "yemen": "Yemen",
        "zambia": "Zambia",
        "zimbabwe": "Zimbabue",
        // 西班牙语
    }],
    ["fr", {
        "afghanistan": "Afghanistan",
        "albania": "Albanie",
        "algeria": "Algérie",
        "american samoa": "Samoa américaines",
        "andorra": "Andorre",
        "angola": "Angola",
        "anguilla": "Anguilla",
        "antigua and barbuda": "Antigua-et-Barbuda",
        "argentina": "Argentine",
        "armenia": "Arménie",
        "aruba": "Aruba",
        "australia": "Australie",
        "austria": "Autriche",
        "azerbaijan": "Azerbaïdjan",
        "bahamas": "Bahamas",
        "bahrain": "Bahreïn",
        "bangladesh": "Bangladesh",
        "barbados": "Barbade",
        "belarus": "Biélorussie",
        "belgium": "Belgique",
        "belize": "Belize",
        "benin": "Bénin",
        "bermuda": "Bermudes",
        "bhutan": "Bhoutan",
        "bolivia": "Bolivie",
        "botswana": "Botswana",
        "brazil": "Brésil",
        "bulgaria": "Bulgarie",
        "burkina faso": "Burkina Faso",
        "burundi": "Burundi",
        "cambodia": "Cambodge",
        "cameroon": "Cameroun",
        "canada": "Canada",
        "cape verde": "Cap-Vert",
        "cayman islands": "Îles Caïmans",
        "central african republic": "République centrafricaine",
        "chad": "Tchad",
        "chile": "Chili",
        "christmas island": "Île Christmas",
        "cocos (keeling) islands": "Îles Cocos (Keeling)",
        "colombia": "Colombie",
        "comoros": "Comores",
        "cook islands": "Îles Cook",
        "costa rica": "Costa Rica",
        "cote d'ivoire": "Côte d'Ivoire",
        "croatia": "Croatie",
        "cyprus": "Chypre",
        "czech republic": "République tchèque",
        "denmark": "Danemark",
        "djibouti": "Djibouti",
        "dominica": "Dominique",
        "dominican republic": "République dominicaine",
        "ecuador": "Équateur",
        "egypt": "Égypte",
        "el salvador": "Salvador",
        "equatorial guinea": "Guinée équatoriale",
        "eritrea": "Érythrée",
        "estonia": "Estonie",
        "ethiopia": "Éthiopie",
        "falkland islands (malvinas)": "Îles Malvinas (Falkland)",
        "faroe islands": "Îles Féroé",
        "fiji": "Fidji",
        "finland": "Finlande",
        "france": "France",
        "french guiana": "Guyane française",
        "french polynesia": "Polynésie française",
        "gabon": "Gabon",
        "gambia": "Gambie",
        "georgia": "Géorgie",
        "germany": "Allemagne",
        "ghana": "Ghana",
        "gibraltar": "Gibraltar",
        "greece": "Grèce",
        "greenland": "Groenland",
        "grenada": "Grenade",
        "guadeloupe": "Guadeloupe",
        "guam": "Guam",
        "guatemala": "Guatemala",
        "guinea": "Guinée",
        "guinea-bissau": "Guinée-Bissau",
        "guyana": "Guyane",
        "haiti": "Haïti",
        "honduras": "Honduras",
        "hungary": "Hongrie",
        "iceland": "Islande",
        "india": "Inde",
        "iraq": "Irak",
        "ireland": "Irlande",
        "israel": "Israël",
        "italy": "Italie",
        "jamaica": "Jamaïque",
        "japan": "Japon",
        "jordan": "Jordanie",
        "kazakhstan": "Kazakhstan",
        "kenya": "Kenya",
        "kiribati": "Kiribati",
        "kuwait": "Koweït",
        "kyrgyzstan": "Kirghizistan",
        "lao people's democratic republic": "République démocratique populaire lao",
        "latvia": "Lettonie",
        "lebanon": "Liban",
        "lesotho": "Lesotho",
        "liberia": "Liberia",
        "liechtenstein": "Liechtenstein",
        "lithuania": "Lituanie",
        "luxembourg": "Luxembourg",
        "madagascar": "Madagascar",
        "malawi": "Malawi",
        "malaysia": "Malaisie",
        "maldives": "Maldives",
        "mali": "Mali",
        "malta": "Malte",
        "marshall islands": "Îles Marshall",
        "martinique": "Martinique",
        "mauritania": "Mauritanie",
        "mauritius": "Maurice",
        "mayotte": "Mayotte",
        "mexico": "Mexique",
        "monaco": "Monaco",
        "mongolia": "Mongolie",
        "montserrat": "Montserrat",
        "morocco": "Maroc",
        "mozambique": "Mozambique",
        "myanmar": "Myanmar",
        "namibia": "Namibie",
        "nauru": "Nauru",
        "nepal": "Népal",
        "netherlands": "Pays-Bas",
        "netherlands antilles": "Antilles néerlandaises",
        "new caledonia": "Nouvelle-Calédonie",
        "new zealand": "Nouvelle-Zélande",
        "nicaragua": "Nicaragua",
        "niger": "Niger",
        "nigeria": "Nigéria",
        "niue": "Niue",
        "norfolk island": "Île Norfolk",
        "northern mariana islands": "Îles Mariannes du Nord",
        "norway": "Norvège",
        "oman": "Oman",
        "pakistan": "Pakistan",
        "palau": "Palau",
        "panama": "Panama",
        "papua new guinea": "Papouasie-Nouvelle-Guinée",
        "paraguay": "Paraguay",
        "peru": "Pérou",
        "philippines": "Philippines",
        "poland": "Pologne",
        "portugal": "Portugal",
        "puerto rico": "Porto Rico",
        "qatar": "Qatar",
        "reunion": "La Réunion",
        "romania": "Roumanie",
        "russian federation": "Fédération de Russie",
        "rwanda": "Rwanda",
        "saint kitts and nevis": "Saint-Kitts-et-Nevis",
        "saint lucia": "Sainte-Lucie",
        "saint vincent and the grenadines": "Saint-Vincent-et-les Grenadines",
        "samoa": "Samoa",
        "san marino": "Saint-Marin",
        "sao tome and principe": "Sao Tomé-et-Principe",
        "saudi arabia": "Arabie Saoudite",
        "senegal": "Sénégal",
        "seychelles": "Seychelles",
        "sierra leone": "Sierra Leone",
        "singapore": "Singapour",
        "slovakia": "Slovaquie",
        "slovenia": "Slovénie",
        "solomon islands": "Îles Salomon",
        "somalia": "Somalie",
        "south africa": "Afrique du Sud",
        "south georgia and the south sandwich islands": "Géorgie du Sud et les îles Sandwich du Sud",
        "south korea": "Corée du Sud",
        "spain": "Espagne",
        "sri lanka": "Sri Lanka",
        "suriname": "Suriname",
        "swaziland": "Swaziland",
        "sweden": "Suède",
        "switzerland": "Suisse",
        "tajikistan": "Tadjikistan",
        "thailand": "Thaïlande",
        "timor-leste": "Timor oriental",
        "togo": "Togo",
        "tonga": "Tonga",
        "trinidad and tobago": "Trinité-et-Tobago",
        "tunisia": "Tunisie",
        "turkey": "Turquie",
        "turkmenistan": "Turkménistan",
        "tuvalu": "Tuvalu",
        "uganda": "Ouganda",
        "ukraine": "Ukraine",
        "united arab emirates": "Émirats arabes unis",
        "united kingdom": "Royaume-Uni",
        "united states": "États-Unis",
        "uruguay": "Uruguay",
        "uzbekistan": "Ouzbékistan",
        "vanuatu": "Vanuatu",
        "vatican city state (holy see)": "Cité du Vatican (Saint-Siège)",
        "venezuela": "Venezuela",
        "virgin islands (british)": "Îles Vierges britanniques",
        "virgin islands (u.s.)": "Îles Vierges américaines",
        "wallis and futuna islands": "Îles Wallis et Futuna",
        "yemen": "Yémen",
        "zambia": "Zambie",
        "zimbabwe": "Zimbabwe",
        // 法语
    }],
    ["it", {
        "afghanistan": "Afghanistan",
        "albania": "Albania",
        "algeria": "Algeria",
        "american samoa": "Samoa americane",
        "andorra": "Andorra",
        "angola": "Angola",
        "anguilla": "Anguila",
        "antigua and barbuda": "Antigua e Barbuda",
        "argentina": "Argentina",
        "armenia": "Armenia",
        "aruba": "Aruba",
        "australia": "Australia",
        "austria": "Austria",
        "azerbaijan": "Azerbaigian",
        "bahamas": "Bahamas",
        "bahrain": "Bahrein",
        "bangladesh": "Bangladesh",
        "barbados": "Barbados",
        "belarus": "Bielorussia",
        "belgium": "Belgio",
        "belize": "Belize",
        "benin": "Benin",
        "bermuda": "Bermuda",
        "bhutan": "Bhutan",
        "bolivia": "Bolivia",
        "botswana": "Botswana",
        "brazil": "Brasile",
        "bulgaria": "Bulgaria",
        "burkina faso": "Burkina Faso",
        "burundi": "Burundi",
        "cambodia": "Cambogia",
        "cameroon": "Camerun",
        "canada": "Canada",
        "cape verde": "Capo Verde",
        "cayman islands": "Isole Cayman",
        "central african republic": "Repubblica Centrafricana",
        "chad": "Ciad",
        "chile": "Cile",
        "christmas island": "Isola di Natale",
        "cocos (keeling) islands": "Isole Cocos (Keeling)",
        "colombia": "Colombia",
        "comoros": "Comore",
        "cook islands": "Isole Cook",
        "costa rica": "Costa Rica",
        "cote d'ivoire": "Costa d'Avorio",
        "croatia": "Croazia",
        "cyprus": "Cipro",
        "czech republic": "Repubblica Ceca",
        "denmark": "Danimarca",
        "djibouti": "Gibuti",
        "dominica": "Dominica",
        "dominican republic": "Repubblica Dominicana",
        "ecuador": "Ecuador",
        "egypt": "Egitto",
        "el salvador": "El Salvador",
        "equatorial guinea": "Guinea Equatoriale",
        "eritrea": "Eritrea",
        "estonia": "Estonia",
        "ethiopia": "Etiopia",
        "falkland islands (malvinas)": "Isole Falkland (Malvinas)",
        "faroe islands": "Isole Faroe",
        "fiji": "Figi",
        "finland": "Finlandia",
        "france": "Francia",
        "french guiana": "Guyana francese",
        "french polynesia": "Polinesia francese",
        "gabon": "Gabon",
        "gambia": "Gambia",
        "georgia": "Georgia",
        "germany": "Germania",
        "ghana": "Ghana",
        "gibraltar": "Gibilterra",
        "greece": "Grecia",
        "greenland": "Groenlandia",
        "grenada": "Grenada",
        "guadeloupe": "Guadalupa",
        "guam": "Guam",
        "guatemala": "Guatemala",
        "guinea": "Guinea",
        "guinea-bissau": "Guinea-Bissau",
        "guyana": "Guyana",
        "haiti": "Haiti",
        "honduras": "Honduras",
        "hungary": "Ungheria",
        "iceland": "Islanda",
        "india": "India",
        "iraq": "Iraq",
        "ireland": "Irlanda",
        "israel": "Israele",
        "italy": "Italia",
        "jamaica": "Giamaica",
        "japan": "Giappone",
        "jordan": "Giordania",
        "kazakhstan": "Kazakhstan",
        "kenya": "Kenya",
        "kiribati": "Kiribati",
        "kuwait": "Kuwait",
        "kyrgyzstan": "Kirghizistan",
        "lao people's democratic republic": "Repubblica Democratica Popolare del Laos",
        "latvia": "Lettonia",
        "lebanon": "Libano",
        "lesotho": "Lesotho",
        "liberia": "Liberia",
        "liechtenstein": "Liechtenstein",
        "lithuania": "Lituania",
        "luxembourg": "Lussemburgo",
        "madagascar": "Madagascar",
        "malawi": "Malawi",
        "malaysia": "Malesia",
        "maldives": "Maldive",
        "mali": "Mali",
        "malta": "Malta",
        "marshall islands": "Isole Marshall",
        "martinique": "Martinica",
        "mauritania": "Mauritania",
        "mauritius": "Mauritius",
        "mayotte": "Mayotte",
        "mexico": "Messico",
        "monaco": "Monaco",
        "mongolia": "Mongolia",
        "montserrat": "Montserrat",
        "morocco": "Marocco",
        "mozambique": "Mozambico",
        "myanmar": "Myanmar",
        "namibia": "Namibia",
        "nauru": "Nauru",
        "nepal": "Nepal",
        "netherlands": "Paesi Bassi",
        "netherlands antilles": "Antille Olandesi",
        "new caledonia": "Nuova Caledonia",
        "new zealand": "Nuova Zelanda",
        "nicaragua": "Nicaragua",
        "niger": "Niger",
        "nigeria": "Nigeria",
        "niue": "Niue",
        "norfolk island": "Isola Norfolk",
        "northern mariana islands": "Isole Marianne Settentrionali",
        "norway": "Norvegia",
        "oman": "Oman",
        "pakistan": "Pakistan",
        "palau": "Palau",
        "panama": "Panama",
        "papua new guinea": "Papua Nuova Guinea",
        "paraguay": "Paraguay",
        "peru": "Perù",
        "philippines": "Filippine",
        "poland": "Polonia",
        "portugal": "Portogallo",
        "puerto rico": "Porto Rico",
        "qatar": "Qatar",
        "reunion": "Riunione",
        "romania": "Romania",
        "russian federation": "Federazione Russa",
        "rwanda": "Ruanda",
        "saint kitts and nevis": "Saint Kitts e Nevis",
        "saint lucia": "Santa Lucia",
        "saint vincent and the grenadines": "Saint Vincent e Grenadine",
        "samoa": "Samoa",
        "san marino": "San Marino",
        "sao tome and principe": "São Tomé e Príncipe",
        "saudi arabia": "Arabia Saudita",
        "senegal": "Senegal",
        "seychelles": "Seychelles",
        "sierra leone": "Sierra Leone",
        "singapore": "Singapore",
        "slovakia": "Slovacchia",
        "slovenia": "Slovenia",
        "solomon islands": "Isole Salomone",
        "somalia": "Somalia",
        "south africa": "Sudafrica",
        "south georgia and the south sandwich islands": "Georgia del Sud e Isole Sandwich del Sud",
        "south korea": "Corea del Sud",
        "spain": "Spagna",
        "sri lanka": "Sri Lanka",
        "suriname": "Suriname",
        "swaziland": "Swaziland",
        "sweden": "Svezia",
        "switzerland": "Svizzera",
        "tajikistan": "Tagikistan",
        "thailand": "Thailandia",
        "timor-leste": "Timor Est",
        "togo": "Togo",
        "tonga": "Tonga",
        "trinidad and tobago": "Trinidad e Tobago",
        "tunisia": "Tunisia",
        "turkey": "Turchia",
        "turkmenistan": "Turkmenistan",
        "tuvalu": "Tuvalu",
        "uganda": "Uganda",
        "ukraine": "Ucraina",
        "united arab emirates": "Emirati Arabi Uniti",
        "united kingdom": "Regno Unito",
        "united states": "Stati Uniti",
        "uruguay": "Uruguay",
        "uzbekistan": "Uzbekistan",
        "vanuatu": "Vanuatu",
        "vatican city state (holy see)": "Stato della Città del Vaticano (Santa Sede)",
        "venezuela": "Venezuela",
        "virgin islands (british)": "Isole Vergini Britanniche",
        "virgin islands (u.s.)": "Isole Vergini Americane",
        "wallis and futuna islands": "Isole Wallis e Futuna",
        "yemen": "Yemen",
        "zambia": "Zambia",
        "zimbabwe": "Zimbabue",
        // 意大利语
    }],
    ["de", {
        "afghanistan": "Afghanistan",
        "albania": "Albanien",
        "algeria": "Algerien",
        "american samoa": "Amerikanisch-Samoa",
        "andorra": "Andorra",
        "angola": "Angola",
        "anguilla": "Anguilla",
        "antigua and barbuda": "Antigua und Barbuda",
        "argentina": "Argentinien",
        "armenia": "Armenien",
        "aruba": "Aruba",
        "australia": "Australien",
        "austria": "Österreich",
        "azerbaijan": "Aserbaidschan",
        "bahamas": "Bahamas",
        "bahrain": "Bahrain",
        "bangladesh": "Bangladesch",
        "barbados": "Barbados",
        "belarus": "Weißrussland",
        "belgium": "Belgien",
        "belize": "Belize",
        "benin": "Benin",
        "bermuda": "Bermuda",
        "bhutan": "Bhutan",
        "bolivia": "Bolivien",
        "botswana": "Botswana",
        "brazil": "Brasilien",
        "bulgaria": "Bulgarien",
        "burkina faso": "Burkina Faso",
        "burundi": "Burundi",
        "cambodia": "Kambodscha",
        "cameroon": "Kamerun",
        "canada": "Kanada",
        "cape verde": "Kap Verde",
        "cayman islands": "Kaimaninseln",
        "central african republic": "Zentralafrikanische Republik",
        "chad": "Tschad",
        "chile": "Chile",
        "christmas island": "Weihnachtsinsel",
        "cocos (keeling) islands": "Kokosinseln (Keeling)",
        "colombia": "Kolumbien",
        "comoros": "Komoren",
        "cook islands": "Cookinseln",
        "costa rica": "Costa Rica",
        "cote d'ivoire": "Elfenbeinküste",
        "croatia": "Kroatien",
        "cyprus": "Zypern",
        "czech republic": "Tschechische Republik",
        "denmark": "Dänemark",
        "djibouti": "Dschibuti",
        "dominica": "Dominica",
        "dominican republic": "Dominikanische Republik",
        "ecuador": "Ecuador",
        "egypt": "Ägypten",
        "el salvador": "El Salvador",
        "equatorial guinea": "Äquatorialguinea",
        "eritrea": "Eritrea",
        "estonia": "Estland",
        "ethiopia": "Äthiopien",
        "falkland islands (malvinas)": "Falklandinseln (Malvinas)",
        "faroe islands": "Färöer-Inseln",
        "fiji": "Fidschi",
        "finland": "Finnland",
        "france": "Frankreich",
        "french guiana": "Französisch-Guayana",
        "french polynesia": "Französisch-Polynesien",
        "gabon": "Gabun",
        "gambia": "Gambia",
        "georgia": "Georgien",
        "germany": "Deutschland",
        "ghana": "Ghana",
        "gibraltar": "Gibraltar",
        "greece": "Griechenland",
        "greenland": "Grönland",
        "grenada": "Grenada",
        "guadeloupe": "Guadeloupe",
        "guam": "Guam",
        "guatemala": "Guatemala",
        "guinea": "Guinea",
        "guinea-bissau": "Guinea-Bissau",
        "guyana": "Guyana",
        "haiti": "Haiti",
        "honduras": "Honduras",
        "hungary": "Ungarn",
        "iceland": "Island",
        "india": "Indien",
        "iraq": "Irak",
        "ireland": "Irland",
        "israel": "Israel",
        "italy": "Italien",
        "jamaica": "Jamaika",
        "japan": "Japan",
        "jordan": "Jordanien",
        "kazakhstan": "Kasachstan",
        "kenya": "Kenia",
        "kiribati": "Kiribati",
        "kuwait": "Kuwait",
        "kyrgyzstan": "Kirgistan",
        "lao people's democratic republic": "Laos",
        "latvia": "Lettland",
        "lebanon": "Libanon",
        "lesotho": "Lesotho",
        "liberia": "Liberia",
        "liechtenstein": "Liechtenstein",
        "lithuania": "Litauen",
        "luxembourg": "Luxemburg",
        "madagascar": "Madagaskar",
        "malawi": "Malawi",
        "malaysia": "Malaysia",
        "maldives": "Malediven",
        "mali": "Mali",
        "malta": "Malta",
        "marshall islands": "Marshallinseln",
        "martinique": "Martinique",
        "mauritania": "Mauretanien",
        "mauritius": "Mauritius",
        "mayotte": "Mayotte",
        "mexico": "Mexiko",
        "monaco": "Monaco",
        "mongolia": "Mongolei",
        "montserrat": "Montserrat",
        "morocco": "Marokko",
        "mozambique": "Mosambik",
        "myanmar": "Myanmar",
        "namibia": "Namibia",
        "nauru": "Nauru",
        "nepal": "Nepal",
        "netherlands": "Niederlande",
        "netherlands antilles": "Niederländische Antillen",
        "new caledonia": "Neukaledonien",
        "new zealand": "Neuseeland",
        "nicaragua": "Nicaragua",
        "niger": "Niger",
        "nigeria": "Nigeria",
        "niue": "Niue",
        "norfolk island": "Norfolkinsel",
        "northern mariana islands": "Nördliche Marianen",
        "norway": "Norwegen",
        "oman": "Oman",
        "pakistan": "Pakistan",
        "palau": "Palau",
        "panama": "Panama",
        "papua new guinea": "Papua-Neuguinea",
        "paraguay": "Paraguay",
        "peru": "Peru",
        "philippines": "Philippinen",
        "poland": "Polen",
        "portugal": "Portugal",
        "puerto rico": "Puerto Rico",
        "qatar": "Katar",
        "reunion": "Réunion",
        "romania": "Rumänien",
        "russian federation": "Russische Föderation",
        "rwanda": "Ruanda",
        "saint kitts and nevis": "Saint Kitts und Nevis",
        "saint lucia": "Sankt Lucia",
        "saint vincent and the grenadines": "Sankt Vincent und die Grenadinen",
        "samoa": "Samoa",
        "san marino": "San Marino",
        "sao tome and principe": "São Tomé und Príncipe",
        "saudi arabia": "Saudi-Arabien",
        "senegal": "Senegal",
        "seychelles": "Seychellen",
        "sierra leone": "Sierra Leone",
        "singapore": "Singapur",
        "slovakia": "Slowakei",
        "slovenia": "Slowenien",
        "solomon islands": "Salomonen",
        "somalia": "Somalia",
        "south africa": "Südafrika",
        "south georgia and the south sandwich islands": "Südgeorgien und die Südlichen Sandwichinseln",
        "south korea": "Südkorea",
        "spain": "Spanien",
        "sri lanka": "Sri Lanka",
        "suriname": "Surinam",
        "swaziland": "Swasiland",
        "sweden": "Schweden",
        "switzerland": "Schweiz",
        "tajikistan": "Tadschikistan",
        "thailand": "Thailand",
        "timor-leste": "Osttimor",
        "togo": "Togo",
        "tonga": "Tonga",
        "trinidad and tobago": "Trinidad und Tobago",
        "tunisia": "Tunesien",
        "turkey": "Türkei",
        "turkmenistan": "Turkmenistan",
        "tuvalu": "Tuvalu",
        "uganda": "Uganda",
        "ukraine": "Ukraine",
        "united arab emirates": "Vereinigte Arabische Emirate",
        "united kingdom": "Vereinigtes Königreich",
        "united states": "Vereinigte Staaten",
        "uruguay": "Uruguay",
        "uzbekistan": "Usbekistan",
        "vanuatu": "Vanuatu",
        "vatican city state (holy see)": "Vatikanstadt (Heiliger Stuhl)",
        "venezuela": "Venezuela",
        "virgin islands (british)": "Britische Jungferninseln",
        "virgin islands (u.s.)": "Amerikanische Jungferninseln",
        "wallis and futuna islands": "Wallis- und Futuna-Inseln",
        "yemen": "Jemen",
        "zambia": "Sambia",
        "zimbabwe": "Simbabwe"
        // 德语
    }]
]);

// 获取当前语言，默认为英语
const getCurrentLanguage = () => {
    const language = localStorage.getItem('language'); // 从localStorage获取语言
    return language ? language : 'en'; // 默认返回英语
};

// i18函数根据当前语言返回翻译的内容
export const i18 = (key, values = {}) => {
    key = key?.toLowerCase();
    const currentLanguage = getCurrentLanguage(); // 获取当前语言
    const languageTranslations = translations.get(currentLanguage); // 获取当前语言的翻译数据

    let translation = languageTranslations && languageTranslations[key] ? languageTranslations[key] : key; // 获取翻译，如果没有找到，则返回原始key

    // 动态替换占位符
    for (const placeholder in values) {
        const regex = new RegExp(`\\$\\{${placeholder}\\}`, 'g'); // 创建匹配占位符的正则表达式
        translation = translation.replace(regex, values[placeholder]); // 替换占位符
    }

    return translation; // 返回最终的翻译字符串
};

